import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HomeProducts from "../components/HomeProducts";
import ProductsBanner from "../components/ProductsBanner";
import Categories from "../components/Categories";
import WhatsAppFloatingButton from "../components/WhatsAppFloatingButton";
import { Helmet } from "react-helmet";
const Products = () => {
  const homeProductsData = [
    {
      name: "Blood Glucose",
      image: "/images/Dr Chek D (GOD)_270x270.webp",
      description: "Advanced monitoring for diabetes management.",
      link: "/products/blood-glucose-monitor",
    },
    {
      name: "Blood Pressure",
      image:
        "https://www.sinocare.com/uploadfiles/20241128/2024112816060300765.png",
      description: "Accurate and reliable BP measurement devices.",
    },
    {
      name: "Multi-Function Meter",
      image:
        "https://www.sinocare.com/uploadfiles/20241125/2024112510443700629.png",
      description: "All-in-one health monitoring solution.",
    },
    {
      name: "Hospital & Primary Healthcare",
      image:
        "https://www.sinocare.com/uploadfiles/20241125/2024112510444500052.png",
      description: "Essential tools for medical professionals.",
    },
    {
      name: "More Products",
      image:
        "https://www.sinocare.com/uploadfiles/20241125/2024112510445200998.png",
      description: "Explore our complete range of healthcare devices.",
    },
  ];

  const categoryProductsData = [
    // ✅ Now properly assigned
    /*blood-pressure*/

    {
      name: "Dr. Chek D+ ",
      image: "/images/Dr Chek D+ (GDH)  Meter Image_270x270.webp",
      description: "Advanced monitoring for diabetes management.",
      category: "Blood Glucose",
      details: [
        "Match EN ISO 15197:2015",
        "No coding",
        "0.6μL blood sample",
        "Strip ejector",
      ], // <-- Ensure there is a comma here after 'Strip ejector'
      link: "/blood-glucose-meter-plus", // <-- Ensure this line has a comma if it's followed by more properties
    },
    {
      name: "Dr. Chek D",
      image: "/images/Dr Chek D (GOD)_270x270.webp",
      description: "Advanced monitoring for diabetes management.",
      category: "Blood Glucose",
      details: [
        "Match EN ISO 15197:2015",
        "No coding",
        "0.6μL blood sample",
        "Strip ejector",
      ], // <-- Ensure there is a comma here after 'Strip ejector'
      link: "/blood-glucose-meter", // <-- Ensure this line has a comma if it's followed by more properties
    },
    {
      name: "Dr. Chek H ",
      image: "/images/Dr Chek H_270x270.webp",
      description: "All-in-one health monitoring solution.",
      category: "Blood Hemoglobin",
      details: [
        "Match EN ISO 15197:2015",
        "No coding",
        "0.6μL blood sample",
        "Strip ejector",
      ], // <-- Ensure there is a comma here after 'Strip ejector'
      link: "/Hemoglobin-meter", // <-- Ensure this line has a comma if it's followed by more properties
    },
    {
      name: "Dr. Chek H+ ",
      image: "/images/Dr Chek H+_270x270.webp",
      description: "All-in-one health monitoring solution.",
      category: "Blood Hemoglobin",
      details: [
        "Match EN ISO 15197:2015",
        "No coding",
        "0.6μL blood sample",
        "Strip ejector",
      ], // <-- Ensure there is a comma here after 'Strip ejector'
      link: "/Hemoglobin-meter-plus", // <-- Ensure this line has a comma if it's followed by more properties
    },
    {
      name: "Dr. Chek BP ",
      image: "/images/Dr Chek BP_270x270.webp",
      description: "Accurate and reliable BP measurement devices.",
      category: "Blood Pressure",
      details: [
        "Match EN ISO 15197:2015",
        "No coding",
        "0.6μL blood sample",
        "Strip ejector",
      ], // <-- Ensure there is a comma here after 'Strip ejector'
      link: "/blood-pressure-meter", // <-- Ensure this line has a comma if it's followed by more properties
    },
    {
      name: "Dr. Chek WBP ",
      image: "/images/Dr Chek WBP_270x270.webp",
      description: "Accurate and reliable BP measurement devices.",
      category: "Blood Pressure",
      details: [
        "Match EN ISO 15197:2015",
        "No coding",
        "0.6μL blood sample",
        "Strip ejector",
      ], // <-- Ensure there is a comma here after 'Strip ejector'
      link: "/blood-pressure-meter-plus", // <-- Ensure this line has a comma if it's followed by more properties
    },
  ];

  return (
    <div>
      <Helmet>
        <title>
          Products - DrChek | Smart Healthcare & Diagnosis Solutions
        </title>
        <meta
          name="description"
          content="Explore DrChek's range of products designed to enhance healthcare and diagnosis, offering cutting-edge technology for efficient medical solutions."
        />
        <meta
          name="keywords"
          content="DrChek Products, Healthcare Solutions, Diagnostic Tools, Smart Health Devices, Medical Equipment"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>

      <Header />
      <ProductsBanner
        title="Our Products"
        backgroundImage="/images/dr-chek-banner-001.png"
        backgrond="cover"
        height="400px"
      />
      {/* <HomeProducts products={homeProductsData} />{" "} */}
      {/* ✅ Passing correct data */}
      {/* <Categories products={categoryProductsData} />{" "} */}
      <Categories products={categoryProductsData} />
      {/* ✅ Now passing category products */}
      <Footer />
      <WhatsAppFloatingButton />
    </div>
  );
};

export default Products;
